import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import {
    userLoginStart,
} from "../../store/actions/UserAction";

import "./Signin.css"

const Login = (props) => {

    const [showPassword, setShowPassword] = useState(false);
    const [loginInputData, setLoginInputData] = useState({});
    const emailRef = useRef(null);

    useEffect(() => {
        emailRef.current.focus();
        const prevTitle = document.title;
        document.title = "Sign In | Rebel";
        return () => {
            document.title = prevTitle;
        };
    }, []);

    const handleLogin = (event) => {
        event.preventDefault();
        props.dispatch(userLoginStart(loginInputData));
    };

    const searchParams = new URLSearchParams(props.location?.search || window.location.search);
    const redirectParam = searchParams.get("redirect");
    const isEventContext = searchParams.get("context") === "event" || (redirectParam && redirectParam.includes("/checkout/"));

    return (
        <div className="signin-wrapper">
            <div className="signin-card">

                {/* LEFT SIDE */}
                <div className="signin-left">
                    <div className="logo-wrapper">
                        <a href="/">
                            <img
                                src="https://admin.rebeltv.me/rebel-homepage-assets/logo.png"
                                alt="logo"
                                className="signin-logo d-inline"
                            />
                        </a>
                    </div>

                    <h2 className="signin-title">SIGN IN</h2>

                    <p className="signin-subtitle">
                        {isEventContext
                            ? "Sign in to your Rebel account to complete your ticket purchase."
                            : "Please login to continue to your account."}
                    </p>

                    <form onSubmit={handleLogin}
                        method="post"
                        autoComplete="off">
                        <div className="auth-form-group">
                            <input
                                type="email"
                                placeholder="Email"
                                className="email-input"
                                ref={emailRef}
                                autoComplete="off"
                                name="email"
                                required
                                value={loginInputData.email}
                                onChange={(event) =>
                                    setLoginInputData({
                                        ...loginInputData,
                                        email: event.currentTarget.value,
                                    })
                                }
                            />
                        </div>

                        <div className="form-group password-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                className="password-input"
                                required
                                autoComplete="off"
                                value={loginInputData.password}
                                name="password"
                                onChange={(event) =>
                                    setLoginInputData({
                                        ...loginInputData,
                                        password: event.currentTarget.value,
                                    })
                                }
                            />
                            <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                                <i
                                    className={
                                        showPassword
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                    }
                                ></i></span>
                        </div>

                        <p className="forgot-text">
                            <a href="/forgot">Forgot Password</a>
                        </p>

                        <button
                            className="signin-btn"
                            disabled={props.login.buttonDisable}
                            type="submit"
                            onClick={handleLogin}
                        >
                            {props.login.loadingButtonContent !== null
                                ? props.login.loadingButtonContent
                                : "Sign In"}
                        </button>

                        <p className="signup-text">
                            Need an account?
                            <a href={`/signup${props.location?.search || window.location.search || ""}`}>Create one</a>
                        </p>
                    </form>
                </div>

            </div>
        </div>
    );
}

const mapStateToPros = (state) => ({
    login: state.users.loginInputData,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(Login));